/******************************************************************************
 *** BgtSpcExpndViewDialog ** 특별회계기금 * 지출결의서 상세정보 모달
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import { budgetFilesProps } from "@/js/common/types/types";
import Util from "@/js/common/Util";
import React from "react";
import BudgetViewFile from "../../budgetFileBox/BudgetViewFile";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import TextBox from "@/js/common/ui/input/TextBox";
import BgtSpcEvdncViewList from "./BgtBrEvdncViewList";
import BgtSpcEvdncViewDialog from "./BgtBrEvdncViewDialog";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import { downloadPdfFromElement } from "@/js/system/common/print/PdfUtil";
import BudgetRsdocPrint from "@/js/system/common/print/BudgetRsdocPrint";

interface Props {
    spcAcntgExpndDocId: string;
    systemCode: string;
    setSpcExpndModalOpen: Function;
}
const BgtSpcExpndViewDialog = ( {spcAcntgExpndDocId, systemCode, setSpcExpndModalOpen}: Props ) => {
    const [expndRsdocNo      , setExpndRsdocNo      ] = React.useState<string>(""); // 결의서 문서번호
    const [implDt            , setImplDt            ] = React.useState<string>(""); // 행위년월일(집행일자)(YYYYMMDD)
    const [bgtSbjct1stCd     , setBgtSbjct1stCd     ] = React.useState<string>(""); // 1차 코드(관)
    const [bgtSbjct2stCd     , setBgtSbjct2stCd     ] = React.useState<string>(""); // 2차 코드(항)
    const [bgtSbjct3stCd     , setBgtSbjct3stCd     ] = React.useState<string>(""); // 3차 코드(목)
    const [abstrCn           , setAbstrCn           ] = React.useState<string>(""); // 적요
    const [memo              , setMemo              ] = React.useState<string>(""); // 메모
    const [implAmt           , setImplAmt           ] = React.useState<string>(""); // 집행금액
    const [crtDt             , setCrtDt             ] = React.useState<string>(""); // 작성일자
    const [atrzSttsCd        , setAtrzSttsCd        ] = React.useState<string>("00"); // 결재상태정보
    const [atrzOpnnCn        , setAtrzOpnnCn        ] = React.useState<string>(""); // 반려사유(결재의견)
    const [listLine, setListLine] = React.useState<any[]>([]);  // 결재 라인 정보
    const [openLine, setOpenLine] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [expndRsdocSeCd        , setExpndRsdocSeCd        ] = React.useState<string>(""); // 지출결의서 구분 코드
    const [_lnkgSpcAcntgExpndDocId, setLnkgSpcAcntgExpndDocId] = React.useState<string>(""); // 연계 지출결의서 문서ID
    const [dataSbmsnCmptnYn      , setDataSbmsnCmptnYn      ] = React.useState<string>(""); // 자료제출 완료여부(Y/N)

    const [savedSpcExpndFiles, setSavedSpcExpndFiles] = React.useState<budgetFilesProps[]>([]); // 저장된 파일

    const [spcAcntgExpndEvdncId, setSpcAcntgExpndEvdncId] = React.useState<string>(""); // 지출증빙 ID
    const [expndEvdncRsdocNo, setExpndEvdncRsdocNo] = React.useState<string>(""); // 지출증빙 번호
    const [evdncView, setEvdncView] = React.useState<string>("N");  // 지출증빙내역서 View Y/N

    const printRef = React.useRef<HTMLDivElement>(null);

    const handlePdfDownload = async () => {
        AppContext.showSpinner();

        await downloadPdfFromElement(
            printRef.current,
            `지출결의서_${expndRsdocNo}.pdf`
        );

        AppContext.hideSpinner();
    };

    // 특별회계기금 지출결의서 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/spc/expnd/select-bgt-spc-expnd-rsdoc-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                spcAcntgExpndDocId: spcAcntgExpndDocId   // 지출결의서 문서 ID
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    setExpndRsdocNo (res.result.item.expndRsdocNo ); // 행위년월일(집행일자)
                    setImplDt       (res.result.item.implDt       ); // 행위년월일(집행일자)
                    setBgtSbjct1stCd(res.result.item.bgtSbjct1stCd); // 1차 코드(관)
                    setBgtSbjct2stCd(res.result.item.bgtSbjct2stCd); // 2차 코드(항)
                    setBgtSbjct3stCd(res.result.item.bgtSbjct3stCd); // 3차 코드(목)
                    setAbstrCn      (res.result.item.abstrCn      ); // 적요
                    setMemo         (res.result.item.memo         ); // 메모
                    setImplAmt      (res.result.item.implAmt      ); // 집행금액
                    setCrtDt        (res.result.item.crtDt        ); // 작성일자
                    setAtrzSttsCd   (res.result.item.atrzSttsCd   ); // 결재상태정보
                    setAtrzOpnnCn   (res.result.item.atrzOpnnCn   ); // 반려사유(결재의견)
                    setListLine(res.result.listLine || []);

                    setExpndRsdocSeCd     (res.result.item.expndRsdocSeCd     ); // 지출결의서 구분 코드
                    setLnkgSpcAcntgExpndDocId(res.result.item.lnkgSpcAcntgExpndDocId); // 연계 지출결의서 ID
                    setDataSbmsnCmptnYn   (res.result.item.dataSbmsnCmptnYn   ); // 자료제출 여부(Y/N)

                    setSavedSpcExpndFiles(res.result.listFile); // 첨부파일
                }
                AppContext.hideSpinner();
            },
        });
    }, [spcAcntgExpndDocId]);

    return (
        <>
        <div className="w100p dpFlx jcC">
            <div className="dpFlx gap14 aiFs">
                <div className="w480 pt10">
                    {/* 지출결의서 상세내용 */}
                    <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
                        <div className="mb10 dpFlx jcSb">
                            <div>
                                <span className="fm-b fs16 fc007bff ls1 fw700">지출결의서 상세내용</span>
                                <span className="fm-b fs13 ls06 fc616EEA ml5">[{Util.getValToCode("ATRZ_STTS_CD", atrzSttsCd)}]</span>
                            </div>
                            <div className={
                                    "dpFlx bd1 bdcE8E8ED aiC gap8 pw12 h24 bdrd20 " +
                                    ( expndRsdocSeCd === "01" ? "bgcDEDEDE" // 일반(gray)
                                    : expndRsdocSeCd === "02" ? "bgcFCA852" // 무증빙(yellow)
                                    : expndRsdocSeCd === "03" ? "bgc96c832" // 여입(grean)
                                    : expndRsdocSeCd === "04" ? "bgc87C6FD" // 자료제출(blue)
                                    : "")
                                }
                            >
                                <span className="fm-b fs13">
                                    { expndRsdocSeCd === "01" ? "일반"
                                    : expndRsdocSeCd === "02" ? "무증빙"
                                    : expndRsdocSeCd === "03" ? "여입"
                                    : expndRsdocSeCd === "04" ? "자료제출"
                                    : ""}
                                </span>
                            </div>

                            {/* 무증빙 자료제출 여부 */}
                            {expndRsdocSeCd === "02" && (
                                <div className="dpFlx bd1 bdcE8E8ED aiC pw12 h24 bdrd20 bgcF7F8F7">
                                    <span className="fm-b fs12">{dataSbmsnCmptnYn}</span>
                                </div>
                            )}

                            {/* 지출결의서 문서 ID */}
                            <div>
                                <span className="fm-b fs13 ls06 fc777777 mr10">{expndRsdocNo}</span>
                            </div>
                        </div>

                        {["03", "04", "05"].includes(atrzSttsCd) && (
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                        />
                        )}

                        {/* 연결 문서번호 */}
                        { (expndRsdocSeCd === "03" || expndRsdocSeCd === "04") && (     // 여입, 자료제출
                            <div className="dpFlx gap10 aiE mb10">
                                {/* 연결 문서번호 */}
                                <div className="flx1">
                                    <div className="h30 dpFlx aiE pb5">
                                        <span className="fm-b fs13 ls06 fc111111">연결 문서번호</span>
                                    </div>
                                    <TextBox value={expndRsdocNo}
                                        width={210} height={36} fontSize={14}
                                        fontFamily="fm-c" color="#333" letterSpacing={-1}
                                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                        style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                        placeholder=""
                                        onChangeFunc={(text: string) => setLnkgSpcAcntgExpndDocId(text)}
                                        mode={"disabled"}
                                    />
                                </div>
                                <div className="flx1 mb10">
                                    <span className="fm-b fs13 ls06 fc878787 ml5">
                                        결재완료 또는 전체 조회에서 확인
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* 행위년월일, 금액 */}
                        <div className="dpFlx gap10 aiE mb10">
                            {/* 금액 */}
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">행위년월일</span>
                                </div>
                                <DatePickerBox value={implDt}
                                    width={210} height={36} fontSize={14}
                                    fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    bgColor={"#F6F6F6"}
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    disabled={true}
                                    onChange={(data: string) => setImplDt(data)}
                                />
                            </div>

                            {/* 집행 가능 금액 */}
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">금액 (원)</span>
                                </div>
                                <div className="w210 h36 dpFlx aiC bsBdb">
                                    <NumberTextBox value={implAmt}
                                        className="bgcFFE6CE w100p h36 bd1 bdrd2"
                                        thousandsGroupStyle="thousand" thousandSeparator=","
                                        placeholder="0"
                                        fontSize={14} fontFamily="fm-c" letterSpacing={-1}
                                        onChange={(data: string) => setImplAmt(data)}
                                        inputClass={"taR mr10"}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 관/항/목 */}
                        <div className="dpFlx mb10">
                            {/* 관 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">관</span>
                                </div>
                                <SelectBox value={bgtSbjct1stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getSpcBgt1CodeArray(systemCode, "02"))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct1stCd(data)}
                                    disabled={true}
                                />
                            </div>

                            {/* 항 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">항</span>
                                </div>
                                <SelectBox value={bgtSbjct2stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getSpcBgt2CodeArray(systemCode, bgtSbjct1stCd))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct2stCd(data)}
                                    disabled={true}
                                />
                            </div>

                            {/* 목 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">목</span>
                                </div>
                                <SelectBox  value={bgtSbjct3stCd}
                                    width={140} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#F6F6F6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getSpcBgt3CodeArray(systemCode, bgtSbjct2stCd))}
                                    placeholder="선택"
                                    onChangeFunc={(data: string) => setBgtSbjct3stCd(data)}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        {/* 적요 */}
                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">적요</span>
                            </div>
                            <TextBox value={abstrCn}
                                width={454} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                onChangeFunc={(text: string) => setAbstrCn(text)}
                                mode={"disabled"}
                            />
                        </div>

                        {/* 메모 */}
                        <div className="dpFlx flxdCol mb5">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">메모</span>
                            </div>
                            <TextBox value={memo}
                                width={454} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
                                onChangeFunc={(text: string) => setMemo(text)}
                                mode={"disabled"}
                            />
                        </div>

                        {/* 첨부파일 */}
                        <BudgetViewFile
                            fileSeCd         = "B02" // 파일구분코드(특별회계기금_지출결의서[B02])
                            savedBudgetFiles = {savedSpcExpndFiles}
                            width = "450px"
                            height = "70px"
                        />

                        {/* 반려 */}
                        {atrzSttsCd === "05" &&
                            <div className="dpFlx flxdCol mb5">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">반려</span>
                                </div>
                                <div className="dpFlx aiFs">
                                    <div className="flxg1 bsBdb">
                                        <textarea
                                            value={atrzOpnnCn}
                                            className="h70 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                            style={{width: "454px"}}
                                            maxLength={2000}
                                            onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        {/* ++++++++++++++++++++ 지출 증빙내역서 목록 +++++++++++++++++++++ */}
                        <BgtSpcEvdncViewList
                            spcAcntgExpndDocId      = {spcAcntgExpndDocId}      // 지출결의서 문서 ID
                            setSpcAcntgExpndEvdncId = {setSpcAcntgExpndEvdncId} // 지출증빙내역서 ID
                            setExpndEvdncRsdocNo = {setExpndEvdncRsdocNo} // 지출증빙내역서 ID
                            evdncView               = {evdncView}  // 지출증빙내역서 View Y/N
                            setEvdncView            = {setEvdncView}
                        ></BgtSpcEvdncViewList>
                    </div>

                    {/* ++++++++++++++++++++ 지출증빙내역서 상세 내용 ++++++++++++++++++++ */}
                    {evdncView === "Y" && (
                        <div className="bd1d9d9d9 bdrd6 bgcWhite p15 mt10">
                            <div className="mb10 dpFlx jcSb">
                                <span className="fm-b fs16 fc009696 ls1 fw700">지출증빙내역서 상세내용</span>
                                <span className="fm-c fs12 fc777777 mt4 mr10">문서번호: {expndEvdncRsdocNo}</span>
                            </div>
                            <BgtSpcEvdncViewDialog
                                spcAcntgExpndEvdncId    = {spcAcntgExpndEvdncId}       // 지출증빙내역서 ID
                            />
                        </div>
                    )}

                    {/* 닫기 버튼 */}
                    <div className="dpFlx jcC pt20 pb20 gap10">
                        <Button buttonName="닫기"
                            width={110} height={42}
                            fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                            variant="styCloseBtn" borderRadius={5}
                            buttonClass="dpFlx aiC jcC op80-hover"
                            onClickFunc={() => setSpcExpndModalOpen(false)}
                        />
                        {atrzSttsCd === "04" && (
                        <Button buttonName="PDF 다운로드"
                            width={130} height={42}
                            fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                            variant="styTempBtn" borderRadius={5}
                            buttonClass="dpFlx aiC jcC op80-hover"
                            onClickFunc={handlePdfDownload}
                        />
                        )}
                    </div>
                </div>
            </div>
        </div>

        {/* 숨김 출력 영역: 모달 바깥 */}
        <div style={{position: "fixed", left: "-9999px", top: 0, width: "210mm", backgroundColor: "#ffffff", zIndex: -1}}
        >
            <div ref={printRef}>
                <BudgetRsdocPrint
                    title={expndRsdocSeCd === "03" ? "여 입 결 의 서" : "지 출 결 의 서"}
                    year={Util.getAcntgYear(implDt)}
                    actDt={implDt}
                    regDt={crtDt}
                    gwan={Util.getSpcBgt1CodeArray(systemCode, "02").find((item: any) => item.code === bgtSbjct1stCd)?.name || ""}
                    hang={Util.getSpcBgt2CodeArray(systemCode, bgtSbjct1stCd).find((item: any) => item.code === bgtSbjct2stCd)?.name || ""}
                    mok={Util.getSpcBgt3CodeArray(systemCode, bgtSbjct2stCd).find((item: any) => item.code === bgtSbjct3stCd)?.name || ""}
                    summary={abstrCn}
                    amount={expndRsdocSeCd === "03" ? Number(String(implAmt).replace(/,/g, ""))*-1 || 0 : Number(String(implAmt).replace(/,/g, "")) || 0}
                    proofNo={expndRsdocNo}
                    rsdocType="EXPND"
                    listLine={listLine}
                />
            </div>
        </div>
    </>
    )
}

export default BgtSpcExpndViewDialog;